// NATIVE 
import React, { useEffect, useState } from 'react';

// INSTALLED 
import { Link, useNavigate, useParams } from 'react-router-dom';
import { deepOrange } from '@mui/material/colors';
import { useDispatch, useSelector } from 'react-redux';
import { Avatar, Box, Breadcrumbs, Button, Card, Checkbox, Chip, Divider, FormControlLabel, Grid, IconButton, Stack, Tabs, Typography } from '@mui/material';
import { Apps, BackHand, Bloodtype, ChildFriendly, FormatAlignJustify, InfoOutlined, LocalPhone, LocationOn, LockReset, MailOutline, Person, PhoneAndroid, PushPin, Security, VpnKey, Edit as EditIcon } from '@mui/icons-material';
import { DetalleBeneficiarios, DetalleContratoyFormularios, DetalleDocumentos, DetalleDotacion, DetalleEducacion, DetalleInformacionLaboral, DetallePermisos, DetalleSeguridadSocial } from './components/stepers/steper-detalles';

// CUSTOM 
import { mtDividerUpTable, timeToClosedToast } from '../../../commons';
import { closeSessionGlobal, formatDateToYmd, hasPemissions, validateResponse } from 'commons/utils';
import { SnackAlert } from 'components/SnackAlert';
import CustomButtonTab from 'components/CustomButtonTab';
import MultipleSnackbars from 'components/MultipleSnackbars';
import { createAplicationUser, storeConvertToUserSystem, updateAplicationUser } from 'store/users_permissions';
import { BreadCrumbsAndTitle } from 'components/generics/BreadCrumbsAndTitle';
import { ModalSessionExpired } from 'components/generics/ModalSessionExpired';
import { InfoModal } from 'components/generics/InfoModal';
import { AvatarUsuariosPermissions } from 'components/AvatarUsuariosPermissions';
import { ModalViewPdfGlobal } from 'components/modals/viwerPdf/ModalViewPdfGlobal';
import { DialogCarnet } from 'components/modals/carnet/DialogCarnet';
import { storeDetailEmployee } from 'store/employee';
import { ChangePasswordModal } from 'components/ChangePasswordModal';





interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{ display: value === index ? "block" : "none", width: "100%" }}
      {...other}
    >
      <Box sx={{ p: 3 }}>{children}</Box>
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const DetailEmployee = () => {


  // USE DISPATCH 
  const dispatch = useDispatch();

    // NAVIGATE 
    const navigate = useNavigate();


  // USE SELECTOR 
  const { employee }:any  = useSelector( (state:any) => state.employee );

   const { id: employeeId }: any = useParams();
  


   // Estado global del modal PDF
  const [showPdfDetail, setShowPdfDetail] = useState(false);
  const [urlRutPdf, setUrlRutPdf]         = useState<string | null>(null);
  const [typeUrl, setTypeUrl]             = useState<string | null>(null);

  
  // USE STATE 
  const [value, setValue] = React.useState(0);
  const [percentaje_employee, setPercentajeEmployee] = React.useState(0);

 
  const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);


  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

   const [modalCarnet, setModalCarnet] = useState(false);
   const [openInfoModal, setOpenInfoModal] = useState(false);
   const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false);

  

  const [alert_snack, setAlertSnack] = React.useState(false);
  const [msgSnack, setMsgSnack] = React.useState({
      msg: '',
      status: 'success'
  });


  const [dataEmployee, setDataEmployee] = useState<any>({
      id: 'N/A',
      name: 'N/A',
      last_name: 'N/A',
      address: 'N/A',
      neighborhood: 'N/A',
      email: 'N/A',
      landline: 'N/A',
      cell_phone: 'N/A',
      birthdate: new Date(),
      rh: 'N/A',
      dominance: 'N/A',
      stratum: 'N/A',
      type_contract: 'N/A',
      employee_avatar: 'N/A',
      user: false,
      appsAccess: [],
      appsSystem: [],
      appsCompany: [],
      position:{
        name: 'N/A'

      },
  });

   const [selectedApps, setSelectedApps] = useState<string[]>([]);

   const [canEdit, setCanEdit] = useState(false);

   useEffect(() => {
     const checkPermissions = async () => {
       const edit = await hasPemissions('modulo.thumano', 'modulo.empleados', 'edit');
       if (edit) setCanEdit(true);
     };
     checkPermissions();
   }, []);


    useEffect(() => {
       detalleCustomer();
    }, []);
   
   
    const detalleCustomer = async() => {
      const result = await dispatch(storeDetailEmployee(employeeId));
      if (!result || !result.ok) {
          navigate("/talento-humano/empleado");
      }
    }

    useEffect(() => {
        if ( employee && Object.keys(employee).length > 0 ) {
             setDataEmployee(employee);
        }
    }, [employee]);

  



// const handleChange = (_: React.SyntheticEvent, newValue: number) => {
//     setValue(newValue);
//   };
  // Función que cualquier tab puede llamar
  const handleOpenPdf = (url: string, urlTypeUrl: string) => {
    setUrlRutPdf(url);
    setTypeUrl(urlTypeUrl);
    setShowPdfDetail(true);
  };




  // CONST FUNCTIONS 
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };


   


  useEffect(() => {
    if (
      selectedApps.length === 0 &&
      Array.isArray(dataEmployee.appsCompany) &&
      Array.isArray(dataEmployee.appsAccess)
    ) {
      const coinciden = dataEmployee.appsCompany.filter( (app:any) =>
        dataEmployee.appsAccess.includes(app)
      );
      setSelectedApps(coinciden);
    }
  }, [dataEmployee.appsAccess, dataEmployee.appsCompany]);


  

  const UpdateUserApp = async (id: string | undefined, status: number, appsUser: string) => {

    try {
      // Aquí iría tu lógica real de actualización en backend
      if (id) {


          // console.log(`Actualizando app existente: ID=${id}, Nuevo status=${status}`);


         const response =  await dispatch( updateAplicationUser(id, dataEmployee.id, status, setPercentajeEmployee) );


          const result = await validateResponse(response, ' ((asignar) aplicacion sistema.) ', {
            setMsgSnack,
            setAlertSnack,
            setModalSessionExpired
          });
        
          if (!result) {
              return false;
          }


          if (response.ok) {

          

            const message:any = {
              msg: status === 1 
                    ? 'Aplicación asignada correctamente.' 
                    : 'Aplicación removida correctamente.',
              status: 'success'
            };
          
            await setMsgSnack(message);
            await setAlertSnack(true);


          }



        // Ejemplo: await dispatch(updateUserAppAction({ id, status }));
      } else {
    
        console.log(`Creando nuevo acceso para app=${appsUser} con status=${status}`);
        
         const response =  await dispatch( createAplicationUser(dataEmployee.id, appsUser,  setPercentajeEmployee) );


          const result = await validateResponse(response, ' ((asignar) aplicacion sistema.) ', {
            setMsgSnack,
            setAlertSnack,
            setModalSessionExpired
          });
        
          if (!result) {
              return false;
          }


          if (response.ok) {

          

            const message:any = {
              msg: status === 1 
                    ? 'Aplicación asignada correctamente.' 
                    : 'Aplicación removida correctamente.',
              status: 'success'
            };
          
            await setMsgSnack(message);
            await setAlertSnack(true);

            if (response.data && response.data.id) {
              setDataEmployee( (prev:any) => ({
                ...prev,
                appsAccess: prev.appsAccess.map((a: any) =>
                  a.appsUser === appsUser && a.id === undefined ? { ...a, id: response.data.id } : a
                ),
              }));
            }

          }

      }
    } catch (error) {
      console.error("Error al actualizar acceso de la app:", error);
    }

  };




 const handleToggle = (app: any) => {
  if (dataEmployee.user) {
    const appAccess:any = dataEmployee.appsAccess.find((a: any) => a.appsUser === app);

    if (appAccess) {
      // Ya existe en appsAccess → alternar su status
      const newStatus:any = appAccess.status === 1 ? 0 : 1;
      UpdateUserApp(appAccess.id, newStatus, app);

      setDataEmployee( (prev:any) => ({
        ...prev,
        appsAccess: prev.appsAccess.map((a: any) =>
          a.appsUser === app ? { ...a, status: newStatus } : a
        ),
      }));

      // Actualizar selectedApps para reflejar el cambio
      setSelectedApps(prev =>
        newStatus === 1
          ? [...prev, app] // activado → añadir
          : prev.filter(item => item !== app) // desactivado → quitar
      );
    } else {
      // No existía → crear nuevo acceso con status = 1
      UpdateUserApp(undefined, 1, app);

      setDataEmployee( (prev:any) => ({
        ...prev,
        appsAccess: [...prev.appsAccess, { appsUser: app, id: undefined, status: 1 }],
      }));

      setSelectedApps(prev => [...prev, app]);
    }
  } else {
    // No es usuario del sistema → manejar solo estado local
    setSelectedApps(prev =>
      prev.includes(app)
        ? prev.filter(item => item !== app)
        : [...prev, app]
    );
  }
};









  const createUserSystem = async(employeeId:string) => {
   
    const havePermissions = await hasPemissions('modulo.thumano', 'modulo.empleados', 'view');
      
    if( !havePermissions ){
        await setMsgSnack({ msg: 'No tienes pemisos para (Crear) empleado sistema.', status: 'error' });
        await setAlertSnack(true);
        return false;                                                             
    }

    if ( selectedApps.length <= 0 ) {
        await setMsgSnack({ msg: 'Debes proporcionar al menos un acceso a un aplicativo.', status: 'error' });
        await setAlertSnack(true);
        return false;  
    }

    const response =  await dispatch( storeConvertToUserSystem(employeeId, selectedApps, setPercentajeEmployee) );

    await validateResponse(response, '((Crear) empleado sistema.)', {
         setMsgSnack,
         setAlertSnack,
         setModalSessionExpired
    }, true);
  }

  const generateCarnet = (employee:any) => {
    setModalCarnet(true);
  }


  const handleCloseModalCarnet = async() => {
       
        setModalCarnet(false);
  } 

  return (
    
     <>

     <ModalSessionExpired  open={modalSessionExpired}  />
     <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
     <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>
         
     <DialogCarnet open={modalCarnet} handleCloseModalCarnet={handleCloseModalCarnet} dataEmployee={employee} />
    

        <BreadCrumbsAndTitle
                    title="Detalle Empleado" 
                    mainModule="Talento Humano" 
                    parent="Lista empleados" 
                    action="/talento-humano/empleados" />

        <Divider sx={{ marginBottom: mtDividerUpTable }}/>

        <Grid container spacing={2}>
            
            {/* INICIO LADO A */}
              <Grid size={3}> 
                <Card
                    sx={{
                      alignItems: 'center',
                      p: 3,
                      borderRadius: 2,
                      boxShadow: 3,
                      bgcolor: 'background.paper',
                    }}
                  >

                  
                  <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2rem', marginTop: '1rem'}}>
                    <AvatarUsuariosPermissions urlImage={dataEmployee?.employee_avatar} typeImage={'image-employee'} />
                  </div>

                  <Typography  sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.10rem', marginTop: 4, textTransform: 'capitalize', fontSynthesisWeight: 400 }}> { `${dataEmployee?.name || ''} ${dataEmployee?.last_name || ''}` } </Typography>

                  <Typography  sx={{ textAlign: 'center',  fontSize: '0.9rem',  textTransform: 'capitalize' }}> { dataEmployee?.position?.name || 'Sin asignar' }  </Typography>

                  {canEdit && (
                    <Box display="flex" justifyContent="center" alignItems="center">
                      <Button
                        sx={{ mt: 2, mb: 1 }}
                        variant="outlined"
                        startIcon={<EditIcon />}
                        color="primary"
                        onClick={() => navigate(`/talento-humano/empleados/${dataEmployee.id}/editar`)}
                      >
                        Editar Empleado
                      </Button>
                    </Box>
                  )}

                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 4, textTransform: 'capitalize', fontSynthesisWeight: 400 }}> <LocationOn fontSize='small' sx={{ marginRight: 1 }} /> { dataEmployee?.address} </Typography> 
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400,wordBreak: 'break-word' }}> <PushPin fontSize='small' sx={{ marginRight: 1 }} /> { dataEmployee?.neighborhood} </Typography> 
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400, wordBreak: 'break-word' }}> <MailOutline fontSize='small' sx={{ marginRight: 1 }} /> { dataEmployee?.email} </Typography>
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400,wordBreak: 'break-word' }}> <LocalPhone fontSize='small' sx={{ marginRight: 1 }} /> { dataEmployee?.landline } </Typography>
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400,wordBreak: 'break-word' }}> <PhoneAndroid fontSize='small' sx={{ marginRight: 1 }} /> { dataEmployee?.cell_phone } </Typography> 
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400,wordBreak: 'break-word' }}> <ChildFriendly fontSize='small' sx={{ marginRight: 1 }} /> { dataEmployee?.birthdate ? formatDateToYmd(dataEmployee.birthdate) : 'N/A' } </Typography> 
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400,wordBreak: 'break-word' }}> <Bloodtype fontSize='small' sx={{ marginRight: 1 }} /> RH: { dataEmployee?.rh } </Typography> 
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400,wordBreak: 'break-word' }}> <BackHand fontSize='small' sx={{ marginRight: 1 }} /> Dominación: { dataEmployee?.dominance } </Typography>     
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400,wordBreak: 'break-word' }}> <FormatAlignJustify fontSize='small' sx={{ marginRight: 1 }} /> Estrato: { dataEmployee?.stratum } </Typography>    
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400,wordBreak: 'break-word' }}> <Person fontSize='small' sx={{ marginRight: 1 }} /> Tipo contrato: { dataEmployee?.contract?.name || (typeof dataEmployee?.type_contract === 'string' ? dataEmployee.type_contract : dataEmployee?.type_contract?.label) || 'N/A' } </Typography>    
                  
                  <Divider/>

                    <Box display="flex" justifyContent="center" alignItems="center">
                      <Button
                        sx={{ my: 2, background: '#1976d2' }}
                        variant="contained"
                        onClick={() => generateCarnet(dataEmployee)}
                        color="primary"
                      >
                        Generar Carnet
                      </Button>
                    </Box>

                  <Divider />

                  {
                     dataEmployee.user 
                      ?
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <Button
                            disabled
                            variant="contained"
                            color="primary">
                            Ya es un usuario del sistema
                          </Button>
                          <IconButton 
                            color="info" 
                            sx={{ ml: 1 }} 
                            onClick={() => setOpenInfoModal(true)}
                          >
                            <InfoOutlined />
                          </IconButton>
                        </Box>
                        <Button
                          sx={{ 
                            mt: 1.5, 
                            bgcolor: '#ed6c02', 
                            color: '#fff', 
                            fontWeight: 600,
                            px: 2,
                            py: 0.8,
                            borderRadius: 1.5,
                            boxShadow: '0 2px 8px rgba(237, 108, 2, 0.35)',
                            '&:hover': { bgcolor: '#e65100', boxShadow: '0 4px 12px rgba(230, 81, 0, 0.45)' } 
                          }}
                          variant="contained"
                          startIcon={<LockReset />}
                          onClick={() => setOpenChangePasswordModal(true)}
                        >
                          CAMBIAR CONTRASEÑA DE MODULOS
                        </Button>
                      </Box>
                      :
                      <Button
                        sx={{ margin: 2 }}
                        variant="contained"
                        onClick={ () => createUserSystem(dataEmployee.id) }
                        color="primary">
                        Crear Como Usuario Sistema
                      </Button>
                      
                  }
                  

                  {
                  dataEmployee && (
                        <Box sx={{ mt: 2 }}>
                          <Typography
                            display="flex"
                            alignItems="center"
                            sx={{
                              fontWeight: 'bold',
                              fontSize: '1rem',
                              mb: 1,
                            }}
                          >
                            <Apps fontSize="small" sx={{ mr: 1 }} />
                            Acceso a aplicativos
                          </Typography>
                  
                          <Stack direction="column" spacing={1} sx={{ pl: 3 }}>
                            {dataEmployee.appsCompany?.map((app:any, index:number) => (
                              <FormControlLabel
                                key={index}
                                control={
                                 <Checkbox
                                    checked={
                                      dataEmployee.user
                                        ? dataEmployee.appsAccess.some((a: any) => a.appsUser === app && a.status === 1)
                                        : selectedApps.includes(app)
                                    }
                                    onChange={() => handleToggle(app)}
                                  />

                                }
                                label={app}
                                sx={{
                                  color: selectedApps.includes(app) ? '#192a56' : 'inherit',
                                  fontWeight: selectedApps.includes(app) ? 700 : 400,
                                }}
                              />
                            ))}
                          </Stack>
                        </Box>
                      )
                  }


                   

                </Card>
              </Grid>
            {/* FIN LADO A  */}





            {/* INICIO LADO B */}
            <Grid size={9}> 
              <Box sx={{ width: '100%' }}>
                {/* <Box sx={{ borderBottom: 1, borderColor: 'divider' }}> */}
                <Box>
                    <Tabs
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        value={value}
                        onChange={handleChange}
                        aria-label="tabs detalle clientes"
                        TabIndicatorProps={{
                          style: { display: "none" },
                        }}
                        TabScrollButtonProps={{
                          sx: {
                            width: 40,   // ancho del botón
                            height: 40,  // alto del botón
                            "& svg": { fontSize: 30 }, // tamaño del ícono
                          },
                        }}
                        selectionFollowsFocus
                      >
                        <CustomButtonTab icon={<Security />} label="Informacion laboral" {...a11yProps(0)} />
                        <CustomButtonTab icon={<Security />} iconPosition="start" label="Educacion" {...a11yProps(1)} />
                        {/* <CustomButtonTab icon={<Security />} iconPosition="start" label="Seguridad social" {...a11yProps(2)} />
                        <CustomButtonTab icon={<Security />} iconPosition="start" label="Documentos" {...a11yProps(3)} /> */}
                        {/* <CustomButtonTab icon={<Security />} iconPosition="start" label="Beneficiarios" {...a11yProps(2)} /> */}
                        <CustomButtonTab icon={<Security />} iconPosition="start" label="Dotacion" {...a11yProps(2)} />
                        <CustomButtonTab icon={<Security />} iconPosition="start" label="Contrato y formularios" {...a11yProps(3)} />
                      </Tabs>
 
                </Box>
              </Box>

              <Card
                  sx={{
                    alignItems: 'center',
                    p: 3,
                    borderRadius: 2,
                    boxShadow: 3,
                    bgcolor: 'background.paper',
                  }}
                >


                <CustomTabPanel value={value} index={0}>
                    {/* <DetallePermisos /> */}
    
                    <DetalleInformacionLaboral onOpenPdf={handleOpenPdf} />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <DetalleEducacion/>
                </CustomTabPanel>
                {/* <CustomTabPanel value={value} index={2}>
                    <DetalleSeguridadSocial />
                </CustomTabPanel> */}
                {/* <CustomTabPanel value={value} index={3}>
                    <DetalleDocumentos />
                </CustomTabPanel> */}
                {/* <CustomTabPanel value={value} index={2}>
                   <DetalleBeneficiarios />
                </CustomTabPanel> */}
                <CustomTabPanel value={value} index={2}>
                   <DetalleDotacion />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={3}>
                   <DetalleContratoyFormularios dataEmployee={employee} />
                </CustomTabPanel>


                {/* 🚀 Modal GLOBAL fuera de los tabs */}
              <ModalViewPdfGlobal
                open={showPdfDetail}
                typeUrl={typeUrl}
                onClose={() => setShowPdfDetail(false)}
                pdfUrl={urlRutPdf}
              />

              <InfoModal 
                open={openInfoModal}
                setOpen={setOpenInfoModal}
                title="Usuario de Sistema"
                description="El empleado ya es un usuario del sistema, por lo que su cuenta principal fue creada anteriormente."
                infoText="Si ves este botón desactivado y ninguna opción seleccionada, puedes habilitar o deshabilitar su acceso a las diferentes aplicaciones utilizando las casillas de verificación que se encuentran en la parte inferior."
                icon="Info"
              />

              <ChangePasswordModal 
                open={openChangePasswordModal} 
                onClose={() => setOpenChangePasswordModal(false)} 
                employeeId={dataEmployee.id}
                employeeName={`${dataEmployee.name || ''} ${dataEmployee.last_name || ''}`}
              />

              </Card>
            </Grid>
            {/* FIN LADO B  */}

            
        </Grid>
     </>
  )
}
